import { Component, ViewChild } from '@angular/core';
import { Item } from './../../../../shared/dropdown/dropdown.models';
import { ClientMaster, Market, SubMarket, Client } from '../../../models/client-master.model';
import { ClientMasterBehaviorService } from '../../../services/client-master-behavior.service';
import { DropdownComponent } from 'src/app/modules/shared/dropdown/dropdown.component';
import { v4 } from 'uuid';
import * as _ from 'lodash';
import { GlobalStoreService } from '../../../services/global-store.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-filter',
    standalone: false,
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss']
})
export class FilterComponent {

    markets: Item[] = [];
    subMarkets: Item[] = [];
    clients: Item[] = [];
    showMarginCost = false;

    @ViewChild('subMarket') subMarketDropDown: DropdownComponent;
    @ViewChild('client') clientDropDown: DropdownComponent;

    filterBy = (i: Item) => i.id !== 0 && i.visible && i.checked;

    constructor(
        private router: Router,
        public globalStore: GlobalStoreService,
        public clientMasterBehavior: ClientMasterBehaviorService) {
        const clientMaster = this.globalStore.clientMaster;
        this.showMarginCost = clientMaster.MarginCost[0].ISMarginCostUpload == undefined ? false : clientMaster.MarginCost[0].ISMarginCostUpload;
/* istanbul ignore else*/
        if (clientMaster.Markets.length) {
            this.markets = [
                {
                    uuid: v4(),
                    id: 0,
                    marketId: 0,
                    subMarketId: 0,
                    name: 'All',
                    checked: true,
                    visible: true
                }
            ];
            this.subMarkets = [
                {
                    uuid: v4(),
                    id: 0,
                    marketId: 0,
                    subMarketId: 0,
                    name: 'All',
                    checked: true,
                    visible: true
                }
            ];
            this.clients = [
                {
                    uuid: v4(),
                    id: 0,
                    marketId: 0,
                    subMarketId: 0,
                    name: 'All',
                    checked: true,
                    visible: true
                }
            ];
        }

        this.markets = [
            ...this.markets,
            ...clientMaster.Markets.map(market => ({
                uuid: v4(),
                id: market.MarketId,
                name: market.MarketName,
                marketId: 0,
                subMarketId: 0,
                checked: true,
                visible: true
            } as Item))];

        this.subMarkets = [
            ...this.subMarkets,
            ...clientMaster.SubMarkets.map(subMarket => ({
                uuid: v4(),
                id: subMarket.SubMarketId,
                name: subMarket.SubMarketName,
                marketId: subMarket.MarketId,
                subMarketId: 0,
                checked: true,
                visible: true
            } as Item))];

        this.clients = [
            ...this.clients,
            ...(
                _.chain(clientMaster.Clients)
                    .map((subMarket, index) => ({
                        uuid: v4(),
                        id: subMarket.ClientId,
                        name: subMarket.ClientName,
                        marketId: subMarket.MarketId,
                        subMarketId: subMarket.SubMarketId,
                        revenueOrder: index,
                        checked: true,
                        visible: true
                    } as Item))
                    .orderBy([i => i.name.toLowerCase()], 'asc')
                    .value()
            )

        ];


        this.onSearchClick();
    }

    get allSubMarket() {
        return this.subMarkets.find(i => i.id === 0);
    }

    get allClient() {
        return this.clients.find(i => i.id === 0);
    }

    get isFilterEmpty() {
        return this.markets.filter(this.filterBy).length === 0 ||
            this.subMarkets.filter(this.filterBy).length === 0 ||
            this.clients.filter(this.filterBy).length === 0;
    }

    everyItemState(items: Item[], checked: boolean) {
        return items.filter(i => i.visible && i.id !== 0).every(i => i.checked === checked);
    }

    isEmpty(items: Item[]) {
        return items.filter(i => i.visible && i.id !== 0).length === 0;
    }

    marketChange($event: any) {
        const checked = $event.$event.target.checked;
        const current = $event.item as Item;

        if (current.id === 0) {
            this.subMarkets.forEach(subMarket => {
                subMarket.checked = checked;
                subMarket.visible = checked;
            });
            this.clients.forEach(client => {
                client.checked = checked;
                client.visible = checked;
            });
        } else {
            const index = this.markets.findIndex(i => i.id === current.id);
            this.markets[index].checked = checked;

            this.markets.forEach(market => {
                this.subMarkets.forEach(subMarket => {
                    if (subMarket.marketId === market.id) {
                        subMarket.checked = market.checked;
                        subMarket.visible = market.checked;
                    }
                });
                this.clients.forEach(client => {
                    if (client.marketId === market.id) {
                        client.checked = market.checked;
                        client.visible = market.checked;
                    }
                });
            });

            const isEveryMarketsUnchecked = this.everyItemState(this.markets, false);
            const isEverySubMarketsChecked = this.everyItemState(this.subMarkets, true);

            this.allSubMarket.checked = isEverySubMarketsChecked;
            this.allSubMarket.visible = true;

            if (isEveryMarketsUnchecked) {
                this.allSubMarket.visible = false;
                this.allSubMarket.checked = false;
            }

            const isEverySubMarketsUnchecked = this.everyItemState(this.subMarkets, false);
            const isEveryClientChecked = this.everyItemState(this.clients, true);

            this.allClient.checked = isEveryClientChecked;
            this.allClient.visible = true;

            if (isEverySubMarketsUnchecked) {
                this.allClient.visible = false;
                this.allClient.checked = false;
            }
        }

        if (this.isEmpty(this.subMarkets)) {
            this.allClient.checked = false;
            this.allClient.visible = false;
        }
        if (this.isEmpty(this.clients)) {
            this.allClient.checked = false;
            this.allClient.visible = false;
        }

        this.subMarketDropDown.search = '';
        this.clientDropDown.search = '';
    }

    subMarketChange($event: any) {
        const checked = $event.$event.target.checked;
        const current = $event.item as Item;

        if (current.id === 0) {
            this.subMarkets.filter(i => i.visible).forEach(subMarket => {
                this.clients.forEach(client => {
                    if (client.subMarketId === subMarket.id) {
                        client.checked = subMarket.checked;
                        client.visible = subMarket.checked;
                    }
                });
            });
        } else {

            const index = this.subMarkets.findIndex(i => i.id === current.id);
            this.subMarkets[index].checked = checked;

            this.subMarkets.filter(i => i.visible).forEach(subMarket => {
                this.clients.forEach(client => {
                    if (client.subMarketId === subMarket.id) {
                        client.checked = subMarket.checked;
                        client.visible = subMarket.checked;
                    }
                });
            });

            const isEverySubMarketsChecked = this.everyItemState(this.subMarkets, true);
            const isEverySubMarketsUnchecked = this.everyItemState(this.subMarkets, false);
            const isEveryClientChecked = this.everyItemState(this.clients, true);

            this.allClient.checked = isEveryClientChecked;
            this.allClient.visible = true;

            if (isEverySubMarketsChecked) {
                this.allSubMarket.visible = true;
                this.allSubMarket.checked = true;
            }
            if (isEverySubMarketsUnchecked) {
                this.allClient.visible = false;
                this.allClient.checked = false;
            }
        }

        if (this.isEmpty(this.clients)) {
            this.allClient.checked = false;
            this.allClient.visible = false;
        }

        this.clientDropDown.search = '';
    }

    onSearchClick() {
        const clientMaster: ClientMaster = {
            Markets: [],
            SubMarkets: [],
            Clients: [],
            visibleClients: []
        };
        const filterBy = (i: Item) => i.id !== 0 && i.visible && i.checked;

        clientMaster.Markets = this.markets.filter(filterBy).map(i => ({
            MarketId: i.id,
            MarketName: i.name
        } as Market));
        clientMaster.SubMarkets = this.subMarkets.filter(filterBy).map(i => ({
            SubMarketId: i.id,
            SubMarketName: i.name,
            MarketId: i.marketId
        } as SubMarket));
        clientMaster.Clients = _.chain(this.clients)
            .filter(filterBy)
            .orderBy([i => i.revenueOrder], 'asc')
            .map(i => ({
                ClientId: i.id,
                ClientName: i.name,
                MarketId: i.marketId,
                SubMarketId: i.subMarketId
            } as Client))
            .value();


        this.clientMasterBehavior.setClientMaster(clientMaster);
    }

    onLaunchReport() {

        const selectedStates = {
            Markets: this.markets,
            SubMarkets: this.subMarkets,
            Clients: this.clients,
        };

        if (!this.isFilterEmpty) {
            localStorage.setItem('clientMaster', JSON.stringify(selectedStates));
        }
        const url = this.router.createUrlTree(['/reports']);
        window.open(url.toString(), '_blank');
    }

    onLaunchMarginCalculator(){
            const selectedStates = {
            Markets: this.markets,
            SubMarkets: this.subMarkets,
            Clients: this.clients,
            };
            if (!this.isFilterEmpty) {
            localStorage.setItem('clientMaster', JSON.stringify(selectedStates));
            }
            const url = this.router.createUrlTree(['/margin-calcuator']);
            window.open(url.toString(), '_blank');
    }

    onLaunchMarginCostUpload(){
        const url = this.router.createUrlTree(['/margin-cost-upload']);
        window.open(url.toString(), '_blank');
    }

    // onLaunchSID() {

    //     const sidclientMaster = this.globalStore.sidclientMaster;
    //     this.clientMasterBehavior.setSIDClientMaster(sidclientMaster);
    //     localStorage.setItem('profile', JSON.stringify(this.globalStore.profile));
    //     const url = this.router.createUrlTree(['/sid']);
    //     const sidWindow = window.open('', '_blank');
    //     if(sidWindow){
    //         sidWindow.opener = null;
    //         sidWindow.location.href = url.toString();
    //     }else{
    //         console.error('Unable to open a new window.');
    //     }
    //     // var sidWindow = window.open(url.toString(), '_blank');
    //     sidWindow.onload = function () {
    //         sidWindow.document.title = "SID";
    //     }
    // }
}
